import UntitledBlackEot from 'fonts/UntitledSansWeb-Black.eot';
import UntitledBlackWoff2 from 'fonts/UntitledSansWeb-Black.woff2';
import UntitledBlackWoff from 'fonts/UntitledSansWeb-Black.woff';

import UntitledBlackItalicEot from 'fonts/UntitledSansWeb-BlackItalic.eot';
import UntitledBlackItalicWoff2 from 'fonts/UntitledSansWeb-BlackItalic.woff2';
import UntitledBlackItalicWoff from 'fonts/UntitledSansWeb-BlackItalic.woff';

import UntitledBoldEot from 'fonts/UntitledSansWeb-Bold.eot';
import UntitledBoldWoff2 from 'fonts/UntitledSansWeb-Bold.woff2';
import UntitledBoldWoff from 'fonts/UntitledSansWeb-Bold.woff';

import UntitledBoldItalicEot from 'fonts/UntitledSansWeb-BoldItalic.eot';
import UntitledBoldItalicWoff2 from 'fonts/UntitledSansWeb-BoldItalic.woff2';
import UntitledBoldItalicWoff from 'fonts/UntitledSansWeb-BoldItalic.woff';

import UntitledLightEot from 'fonts/UntitledSansWeb-Light.eot';
import UntitledLightWoff2 from 'fonts/UntitledSansWeb-Light.woff2';
import UntitledLightWoff from 'fonts/UntitledSansWeb-Light.woff';

import UntitledLightItalicEot from 'fonts/UntitledSansWeb-LightItalic.eot';
import UntitledLightItalicWoff2 from 'fonts/UntitledSansWeb-LightItalic.woff2';
import UntitledLightItalicWoff from 'fonts/UntitledSansWeb-LightItalic.woff';

import UntitledMediumEot from 'fonts/UntitledSansWeb-Medium.eot';
import UntitledMediumWoff2 from 'fonts/UntitledSansWeb-Medium.woff2';
import UntitledMediumWoff from 'fonts/UntitledSansWeb-Medium.woff';

import UntitledMediumItalicEot from 'fonts/UntitledSansWeb-MediumItalic.eot';
import UntitledMediumItalicWoff2 from 'fonts/UntitledSansWeb-MediumItalic.woff2';
import UntitledMediumItalicWoff from 'fonts/UntitledSansWeb-MediumItalic.woff';

import UntitledRegularEot from 'fonts/UntitledSansWeb-Regular.eot';
import UntitledRegularWoff2 from 'fonts/UntitledSansWeb-Regular.woff2';
import UntitledRegularWoff from 'fonts/UntitledSansWeb-Regular.woff';

import UntitledRegularItalicEot from 'fonts/UntitledSansWeb-RegularItalic.eot';
import UntitledRegularItalicWoff2 from 'fonts/UntitledSansWeb-RegularItalic.woff2';
import UntitledRegularItalicWoff from 'fonts/UntitledSansWeb-RegularItalic.woff';

const Fonts = `
    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledBlackEot}) format('embedded-opentype');
        src: url(${UntitledBlackWoff2}) format('woff2'),
            url(${UntitledBlackWoff}) format('woff');
        font-weight: 900;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledBlackItalicEot}) format('embedded-opentype');
        src: url(${UntitledBlackItalicWoff2}) format('woff2'),
            url(${UntitledBlackItalicWoff}) format('woff');
        font-weight: 900;
        font-style: italic;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledBoldEot}) format('embedded-opentype');
        src: url(${UntitledBoldWoff2}) format('woff2'),
            url(${UntitledBoldWoff}) format('woff');
        font-weight: bold;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledBoldItalicEot}) format('embedded-opentype');
        src: url(${UntitledBoldItalicWoff2}) format('woff2'),
            url(${UntitledBoldItalicWoff}) format('woff');
        font-weight: bold;
        font-style: italic;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledLightEot}) format('embedded-opentype');
        src: url(${UntitledLightWoff2}) format('woff2'),
            url(${UntitledLightWoff}) format('woff');
        font-weight: 100;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledLightItalicEot}) format('embedded-opentype');
        src: url(${UntitledLightItalicWoff2}) format('woff2'),
            url(${UntitledLightItalicWoff}) format('woff');
        font-weight: 100;
        font-style: italic;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledMediumEot}) format('embedded-opentype');
        src: url(${UntitledMediumWoff2}) format('woff2'),
            url(${UntitledMediumWoff}) format('woff');
        font-weight: 500;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledMediumItalicEot}) format('embedded-opentype');
        src: url(${UntitledMediumItalicWoff2}) format('woff2'),
            url(${UntitledMediumItalicWoff}) format('woff');
        font-weight: 500;
        font-style: italic;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledRegularEot}) format('embedded-opentype');
        src: url(${UntitledRegularWoff2}) format('woff2'),
            url(${UntitledRegularWoff}) format('woff');
        font-weight: normal;
        font-display: fallback;
    }

    @font-face {
        font-family: 'Untitled';
        src: url(${UntitledRegularItalicEot}) format('embedded-opentype');
        src: url(${UntitledRegularItalicWoff2}) format('woff2'),
            url(${UntitledRegularItalicWoff}) format('woff');
        font-weight: normal;
        font-style: italic;
        font-display: fallback;
    }
`

export default Fonts;